import { render, staticRenderFns } from "./proformaclient_view.vue?vue&type=template&id=32ec7cf8&scoped=true&"
import script from "./proformaclient_view.vue?vue&type=script&lang=js&"
export * from "./proformaclient_view.vue?vue&type=script&lang=js&"
import style0 from "./proformaclient_view.vue?vue&type=style&index=0&id=32ec7cf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec7cf8",
  null
  
)

export default component.exports